export default "__VITE_ASSET__Yar98uEqsg4j$dzO2S0ufw__";